// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 356) return "static/chunks/356-b473667313d09e93.js";
	if (chunkId === 810) return "static/chunks/810-84d7c192b91d1241.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 600 ? "05f6971a" : chunkId) + "." + {"7":"635f1b0eec55203f","123":"fb1ce06784d4327d","331":"04d5db4cc2d66a2c","600":"a53d529ab97a4fab","678":"316591a08e80468e"}[chunkId] + ".js";
};